import { render } from "./RegularMovingByGeoSetting.vue?vue&type=template&id=c9840166&scoped=true"
import script from "./RegularMovingByGeoSetting.vue?vue&type=script&lang=js"
export * from "./RegularMovingByGeoSetting.vue?vue&type=script&lang=js"

import "./RegularMovingByGeoSetting.vue?vue&type=style&index=0&id=c9840166&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9840166"]])

export default __exports__